import useDisableBackground from "../../customHooks/useDisableBackground";

const DarkWrapper = ({
  children,
  isTransparent = false,
  darknessFactor = "0.1",
  env = "wrapper",
}) => {
  const styles = {
    mainLoadingDiv: {
      position: "absolute",
      zIndex: 9000,
      backgroundColor: isTransparent
        ? "transparent"
        : `rgba(0,0,0,${darknessFactor})`,
      height: "100%",
      width: "100%",
      top: 0,
      left: 0,
      
    },
  };

  useDisableBackground({ env: env });

  return (
    <>
      <div style={styles.mainLoadingDiv}>{children}</div>
    </>
  );
};

export default DarkWrapper;
